export const GET_INSIGHTS_BY_JOB_ID_START =
  'INSIGHTS::GET_INSIGHTS_BY_JOB_ID_START';
export const GET_INSIGHTS_BY_JOB_ID_SUCCESS =
  'INSIGHTS::GET_INSIGHTS_BY_JOB_ID_SUCCESS';
export const GET_INSIGHTS_BY_JOB_ID_FAILS =
  'INSIGHTS::GET_INSIGHTS_BY_JOB_ID_FAILS';
